interface EditState {
    editMap: boolean;
    hiddenSidebar: boolean;
    showLibrary: boolean;
}

const EditStore = {
    namespaced: true,
    state: {
        editMap: false,
        hiddenSidebar: false,
        showLibrary: false,
    } as EditState,
    mutations: {
        setEditMap(state: EditState, value: boolean): void {
            state.editMap = value;
        },
        setHiddenSidebar(state: EditState, value: boolean): void {
            state.hiddenSidebar = value;
        },
        toggleHiddenSidebar(state: EditState): void {
            state.hiddenSidebar = !state.hiddenSidebar;
        },
        setShowLibrary(state: EditState, value: boolean): void {
            state.showLibrary = value;
        },
        toggleShowLibrary(state: EditState): void {
            state.showLibrary = !state.showLibrary;
        },
    },
};

export default EditStore;
